<template>
	<div class="goodcase">
		<div class="container">
			<div class="comnewlist" v-for="item in data">
				<div class="left">
					<img :src="item.pic"/>
				</div>
				<div class="center">
					<h2>{{item.title}}</h2>
					<p>{{item.summary}}</p>
				</div>
				<!-- <div class="right">
					<h3>{{item.addtime}}</h3>
					<p>查看详情</p>
				</div> -->
			</div>
		</div>
	</div>
	
</template>

<script>
	export default{
		name:'',
		components:{},
		data(){
			return{
				msg:"公司新闻",
				data:[]
			}
		},
		methods:{
			getList(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.projectGetListApi,
					data: {}
				})
				.then((res) => {
					this.data = res.data.data;
				})
				.catch((err) => {
					console.log(err)
				})
			},
			gotoDetail(id){
				this.$router.push({
				          	path: '/ProjectDetail',
				          	query: {
				          		id:	 id,         
				          	}
				      	})
			},
		},
		created(){
			this.getList();
		}
	}
</script>

<style lang="less" scoped="scoped">
@import url("../../../../styles/main.less");
.goodcase{
	.margin-top(60);
	.comnewlist{
		width: 100%;
		.height(200);
		.margin-bottom(30);
		background: #f7f7f7;
		.padding(10,10,10,10);
		.left{
			display: inline-block;
			width: 24%;
			height: 100%;
			float: left;
			img{
				width: 100%;
				height: 100%;
			}
		}
		.center{
			display: inline-block;
			width: 75%;
			height: 100%;
			float: left;
			.padding-left(30);
			.time{
				.font-size(20);
				span{
					color:#8b8b8b
				}
			}
			h2{
				.font-size(30);
				font-weight: 600;
				.margin-bottom(10);
			}
			p{
				width: 100%;
				overflow: hidden;
				.padding(7,7,7,7);
				.font-size(24);
				display: -webkit-box;
				/* -webkit-box-orient: vertical; */
				/*! autoprefixer: off */
				-webkit-box-orient: vertical;
				/* autoprefixer: on */
				-webkit-line-clamp: 2;
				overflow: hidden;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/ProjectCase/Pcom/Goodcase.vue